<template>
    <div>
        <el-form :model="form" label-width="80px" class="event-form">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="顶班人员">
                        <div class="el-form__inline">
                            <el-input type="text" placeholder="请选择顶班人员" disabled v-model="form.replaceName"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { enable:true, tit:'选择人员',callback:getList } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit">提交</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from './workforce.service.js';
    import { getRules } from "./workforce.rules";
    const rules = getRules();
    export default {
        props:{
            message:Number,
            callback:Function
        },
        data() {
            return {
                // formName:"form",
                // rules:rules,
                form:{
                    replaceName:"",
                    replaceId:"",
                },
            }
        },
        methods: {
            getList(data){//获取选择的调班人员信息
                this.form.replaceName = data.name;
                this.form.replaceId = data.userid;
            },
            submit(){//提交调班信息
                let sendData = {
                    id:this.message,
                    replaceStaffUserid:this.form.replaceId,
                    replaceStaffName:this.form.replaceName,
                }
                services.replaceArrangement(sendData).then(res=>{
                    this.$message.success("调班成功");
                    this.close(true);
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
